export default {
    methods: {
        toLocalDate(d) {
            if (d != null && d != "") {
              const date = new Date(d);
              date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
              return date.toISOString().substring(0, 16);
            }
            return null;
        },
        toISOString(d) {
            if (d != null && d != "") {
              const date = new Date(d);
              return date.toISOString();
            }
            return null;
        }
    }
};
